import { render, staticRenderFns } from "./received.vue?vue&type=template&id=0d56a5d8&scoped=true"
import script from "./received.vue?vue&type=script&lang=js"
export * from "./received.vue?vue&type=script&lang=js"
import style0 from "./received.vue?vue&type=style&index=0&id=0d56a5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56a5d8",
  null
  
)

export default component.exports